import { Skeleton } from '@/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { FC } from 'react';

export const SkeletonTable: FC<{ columnLength: number }> = ({
  columnLength,
}) => {
  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            {[...Array(columnLength)].map((_, i) => (
              <TableHead key={i}>
                <Skeleton className="h-3 w-[80%]" />
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {[...Array(3)].map((_, i) => (
            <TableRow key={i}>
              {[...Array(columnLength)].map((_, i) => (
                <TableCell key={i}>
                  <Skeleton className="h-5 w-[80%]" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
